import { InjectionToken } from '@angular/core';
import { environment } from '../../../environments/environment';

export interface AppConfigInterface {
    endpoints: {
        apiURL: string;
        apiAuthURL: string;
    };
    routes: {
        error404: string;
    };
    snackBarDuration?: number;
    snackBarVerticalPosition?: string;
    apiKey?: string;
    production?: boolean;
}

export const APP_CONFIG = new InjectionToken('app.config');

export const AppConfig: AppConfigInterface = {
    routes: {
        // content: 'content',
        // medic: 'medic',
        error404: '404',
    },
    endpoints: {
        apiURL: environment.apiUrlEnv,
        apiAuthURL: environment.apiAuthUrlEnv,
    },
    snackBarDuration: 10000,
    snackBarVerticalPosition: 'top',
    production: environment.production,
};
